import { Dashboard } from '@interhyp/module-credit';
import { GlobalNotificationBanner } from '@interhyp/shared-credit';
import React, { useMemo } from 'react';

import '@interhyp/shared-credit/esm/index.css';
import '@interhyp/module-credit/esm/index.css';

import { Navigation, NavItems } from '../../navigation/Navigation';

export interface DashboardWrapperProps {
  currentUserId: string;
  providerId: string;
}

export function DashboardWrapper({
  currentUserId,
  providerId,
}: DashboardWrapperProps): JSX.Element {
  const navigationItems: NavItems = useMemo(() => {
    return [
      { to: `/dashboard/`, translation: 'navigation.pipeline' },
      { to: `/archive`, translation: 'navigation.archive' },
    ];
  }, []);

  return (
    <>
      <Navigation navItems={navigationItems} />
      <GlobalNotificationBanner />
      <Dashboard currentUserId={currentUserId} providerId={providerId} />
    </>
  );
}
